module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markWrong-ffff540302d101f11f0337e39c731888.png";